import { useEffect, useState } from "react";
import CSS from "./static/css/ImageZipDownload.module.css";
import download_icon from "./static/img/download_icon_26@3x.png";
import { isHiddenType } from "../../../Common/interface/Common.interface";
import { isHiddenClassNameSetter } from "../../../Common/ts/commonTools";
import { handleFileDownload } from "./static/ts/handleFileDownload";

const ImageZipDownloadIcon = (
    {
        brand_id,
        upload_file_pk,
        file_name,
        isHidden,
        file_size,
    }:{
        brand_id: number;
        upload_file_pk: number;
        file_name?: string;
        isHidden?: isHiddenType;
        file_size?: number;
    }
) => {

    const classNameSetter = () => {
        let RTN: string[] = [];

        RTN.push("g_click_event_item")

        if(isHidden){
            RTN = isHiddenClassNameSetter({
                classNameList: RTN,
                isHidden,
                display: "flex"
            })
        }

        RTN.push(CSS.l_ImageZipDownload_main);

        return RTN;
    }

    const [mainClassName, setMainClassName] = useState<string>(classNameSetter().join(" "));

    useEffect(() => {
        setMainClassName(classNameSetter().join(" "));
    }, [isHidden])

    return(
        <div
            className={mainClassName}
            onClick={() => handleFileDownload({ brand_id, upload_file_pk, file_name, file_size })}
        >
            <img src={download_icon}/>
        </div>
    )
}

export default ImageZipDownloadIcon;